"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SliderUtil = require("./SliderUtil");

var _Handle = _interopRequireDefault(require("./Handle"));

var _Track = _interopRequireDefault(require("./Track"));

var _Mark = _interopRequireDefault(require("./Mark"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Rail =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Rail, _React$Component);

  function Rail(props) {
    var _this;

    _classCallCheck(this, Rail);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Rail).call(this, props)); // Format the props value to proper numbers;

    _this.handleMouseDown = function (e) {
      e.preventDefault();
      var position = e.pageX;

      _this.addEvents();

      _this.onStart(position);
    };

    _this.handleMouseMove = function (e) {
      e.preventDefault();
      var position = e.pageX;

      _this.onMove(e, position);
    };

    _this.handleMouseUp = function (e) {
      e.preventDefault();
      var handle = _this.state.handle;
      var position = e.pageX;

      if (handle) {
        _this.setState(_defineProperty({
          handle: null
        }, handle, _this.calcValueByPos(position)));
      }

      _this.removeEvents();
    };

    var sliderValue = (0, _SliderUtil.getSliderValue)(_this.props.value, _this.props); // If default prop is not available use 0 for normal slider
    // and use [0, 0] - array for range slider

    var defaultValue = _this.props.range ? [0, 0] : 0; // Value of the upperbound active/selected on the rail

    var upperBound; // Value of the lowerbound active/selected on the rail.
    // e.g if it's not range selection, lowerbound will be the min value.

    var lowerBound;

    if (props.range) {
      lowerBound = sliderValue ? sliderValue[0] : defaultValue[0];
      upperBound = sliderValue ? sliderValue[1] : defaultValue[1];

      if (upperBound < lowerBound) {
        upperBound = lowerBound;
      }
    } else {
      lowerBound = props.min;
      upperBound = sliderValue || defaultValue;
    }

    _this.sliderRef = null;
    _this.state = {
      recent: null,
      handle: null,
      upperBound: upperBound,
      lowerBound: lowerBound
    };
    return _this;
  }

  _createClass(Rail, [{
    key: "calcValue",

    /**
     * Calculate the actual input number based on the handle offset on the slider.
     * @param {number} offset - handle offset px from the slider starting position
     * @returns {number} - translated value for input from offset.
     */
    value: function calcValue(offset) {
      var _this$props = this.props,
          min = _this$props.min,
          max = _this$props.max;
      var ratio = Math.abs(offset / this.getSliderLength());
      return ratio * (max - min) + min;
    }
    /**
     * Calculate the handle offset on the slider based on the input value
     * @param {number} value - value shown as input
     * @returns {number} - translated handle offset position.
     */

  }, {
    key: "calcOffset",
    value: function calcOffset(value) {
      var _this$props2 = this.props,
          min = _this$props2.min,
          max = _this$props2.max;
      var ratio = (value - min) / (max - min);
      return ratio * 100;
    }
    /**
     * Calculate the value mapped to the slider with input mouse position.
     * @param {number} position - mouse position
     * @returns {Number} - translated value for input from mouse position
     */

  }, {
    key: "calcValueByPos",
    value: function calcValueByPos(position) {
      var pixelOffset = position - this.getSliderStart();
      var nextValue = (0, _SliderUtil.trimAlignValue)(this.calcValue(pixelOffset), this.props);
      return nextValue;
    }
    /**
     * Return the inner width of an slider rail in pixels
     * @returns {number} - inner width of an slider rail in pixels
     */

  }, {
    key: "getSliderLength",
    value: function getSliderLength() {
      return this.sliderRef ? this.sliderRef.clientWidth : 0;
    }
    /**
     * Return left border position of the slider rail for mouse offset calculation
     * @returns {number} - the left border position of the slider rail
     */

  }, {
    key: "getSliderStart",
    value: function getSliderStart() {
      var slider = this.sliderRef;
      var rect = slider.getBoundingClientRect();
      return rect.left;
    }
  }, {
    key: "addEvents",
    value: function addEvents() {
      document.addEventListener('mousemove', this.handleMouseMove, true);
      document.addEventListener('mouseup', this.handleMouseUp, true);
    }
  }, {
    key: "removeEvents",
    value: function removeEvents() {
      document.removeEventListener('mousemove', this.handleMouseMove, true);
      document.removeEventListener('mouseup', this.handleMouseUp, true);
    }
  }, {
    key: "onStart",
    value: function onStart(position) {
      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;
      var _this$state = this.state,
          lowerBound = _this$state.lowerBound,
          upperBound = _this$state.upperBound;
      var valueNeedChanging = 'upperBound';

      if (this.props.range) {
        var isLowerBoundCloser = Math.abs(upperBound - value) > Math.abs(lowerBound - value);

        if (isLowerBoundCloser) {
          valueNeedChanging = 'lowerBound';
        }

        var isAtTheSamePoint = upperBound === lowerBound;

        if (isAtTheSamePoint) {
          valueNeedChanging = this.state.recent;
        }

        if (isAtTheSamePoint && value !== upperBound) {
          valueNeedChanging = value < upperBound ? 'lowerBound' : 'upperBound';
        }
      }

      this.setState({
        handle: valueNeedChanging,
        recent: valueNeedChanging
      });
      var oldValue = this.state[valueNeedChanging];

      if (value === oldValue) {
        return;
      }

      this.onChange(_defineProperty({
        handle: valueNeedChanging
      }, valueNeedChanging, value));
    }
  }, {
    key: "onChange",
    value: function onChange(state) {
      if (state.handle) {
        this.setState({
          handle: state.handle
        });
      }

      var data = _objectSpread({}, this.state, {}, state);

      var changedValue = this.props.range ? [data.lowerBound, data.upperBound] : data.upperBound;

      if (this.props.onChange) {
        this.props.onChange(changedValue);
      }
    }
  }, {
    key: "onMove",
    value: function onMove(e, position) {
      e.stopPropagation();
      e.preventDefault();
      var props = this.props;
      var state = this.state;
      var diffPosition = position - this.startPosition;
      var diffValue = diffPosition / this.getSliderLength() * (props.max - props.min);
      var value = (0, _SliderUtil.trimAlignValue)(this.startValue + diffValue, this.props);
      var oldValue = state[state.handle];

      if (value === oldValue) {
        return;
      }

      if (value < state.lowerBound && state.handle === 'upperBound') {
        this.onChange({
          handle: 'lowerBound',
          lowerBound: value,
          upperBound: this.state.lowerBound
        });
        return;
      }

      if (value > state.upperBound && state.handle === 'lowerBound') {
        this.onChange({
          handle: 'upperBound',
          upperBound: value,
          lowerBound: this.state.upperBound
        });
        return;
      }

      this.onChange(_defineProperty({}, state.handle, value));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state$this$prop = _objectSpread({}, this.state, {}, this.props),
          max = _this$state$this$prop.max,
          min = _this$state$this$prop.min,
          lowerBound = _this$state$this$prop.lowerBound,
          upperBound = _this$state$this$prop.upperBound,
          range = _this$state$this$prop.range;

      var lowerOffset = this.calcOffset(lowerBound);
      var upperOffset = this.calcOffset(upperBound);
      var width = upperOffset - lowerOffset;

      var sliderRef = function sliderRef(el) {
        _this2.sliderRef = el;
      };

      var minHandleProps = _objectSpread({}, this.props.handleProps, {}, range && this.props.minHandleProps);

      var maxHandleProps = _objectSpread({}, this.props.handleProps, {}, range && this.props.maxHandleProps);

      return _react.default.createElement("div", _extends({
        ref: sliderRef,
        className: "".concat(_ThemeManager.default.getVar('classPrefix'), "-slider-ctr"),
        onMouseDown: this.handleMouseDown
      }, this.props.railProps), _react.default.createElement("div", {
        className: "".concat(_ThemeManager.default.getVar('classPrefix'), "-slider-rail")
      }), _react.default.createElement(_Track.default, {
        offset: lowerOffset,
        width: width
      }), _react.default.createElement(_Mark.default, {
        step: this.props.step,
        max: max,
        min: min,
        lowerBound: lowerBound,
        upperBound: upperBound
      }), range && _react.default.createElement(_Handle.default, {
        tooltip: this.props.tooltip,
        offset: lowerOffset,
        value: lowerBound,
        handleProps: minHandleProps
      }), _react.default.createElement(_Handle.default, {
        tooltip: this.props.tooltip,
        offset: upperOffset,
        value: upperBound,
        handleProps: maxHandleProps
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var lowerBound = state.lowerBound,
          upperBound = state.upperBound;

      if (props.range) {
        var _value = props.value || [lowerBound, upperBound];

        if (_value[0] === lowerBound && _value[1] === upperBound) {
          return null;
        }

        var _sliderValue = (0, _SliderUtil.getSliderValue)(_value, props);

        return _objectSpread({}, state, {
          upperBound: _sliderValue[1] < _sliderValue[0] ? _sliderValue[0] : _sliderValue[1],
          lowerBound: _sliderValue[0]
        });
      }

      var value = props.value !== undefined ? props.value : upperBound;

      if (value === upperBound && lowerBound === props.min) {
        return null;
      }

      var sliderValue = (0, _SliderUtil.getSliderValue)(value, props);
      return _objectSpread({}, state, {
        upperBound: sliderValue,
        lowerBound: props.min
      });
    }
  }]);

  return Rail;
}(_react.default.Component);

exports.default = Rail;
Rail.defaultProps = {
  range: false,
  min: 0,
  max: 100,
  tooltip: false
};
Rail.propTypes = {
  /**
   * Slider callback when value changes
   */
  onChange: _propTypes.default.func,

  /**
   * Slider with single value or range.
   */
  range: _propTypes.default.bool,

  /**
   * Slider with tooltip
   */
  tooltip: _propTypes.default.bool,

  /**
   * Minimum value of the slider
   */
  min: _propTypes.default.number,

  /**
   * Maximum value of the slider
   */
  max: _propTypes.default.number,

  /**
   * Step interval of the slider
   */
  step: _propTypes.default.number,

  /**
   * Input value of the the slider.  The number(s)
   * must be within the range of min and max.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.number, _propTypes.default.string]),

  /**
   * Props to pass to rail element
   */
  railProps: _propTypes.default.object,

  /**
   * Props to pass to Handle component
   */
  handleProps: _propTypes.default.object,

  /**
   * Props to pass to min Handle component when range is defined
   */
  minHandleProps: _propTypes.default.object,

  /**
   * Props to pass to max Handle component when range is defined
   */
  maxHandleProps: _propTypes.default.object
};